// import { DoubleSide, MeshBasicMaterial } from "three";
import {
  Box3,
  DoubleSide,
  Group,
  Mesh,
  MeshBasicMaterial,
  PlaneBufferGeometry,
  Vector3,
} from "three";
import { mainCamera } from "../../cameras";
import {
  createSpacedText,
  createText,
  FONT_BOLD,
  // guiControls,
  // guiSpacingControls,
} from "../../utils/text";
import InteractiveObject from "../../utils/interactive-object";
import { toggleCursor } from "../../renderer";
import { EventEmitter } from "eventemitter3";

const hiddenMaterial = new MeshBasicMaterial({
  side: DoubleSide,
  opacity: 0,
  transparent: true,
  depthTest: false,
  depthWrite: false,
});

export default class Title extends EventEmitter {
  constructor(gui, data, titleMaterial, subtitleMaterial, content) {
    super();
    this.gui = gui.addFolder(`title ${data.title}`);
    // this.gui.open();

    this.data = data;
    this.group = new Group();

    this.titleMesh = createSpacedText(
      data.title.toUpperCase(),
      titleMaterial,
      0.65,
      FONT_BOLD,
      2
    );
    this.subtitleMesh = createText(
      data.subtitle,
      subtitleMaterial,
      1,
      FONT_BOLD,
      1
    );
    this.group.add(this.titleMesh, this.subtitleMesh);
    this.group.add(this.titleMesh);

    this.titleMesh.position.fromArray(content.text.title.position);
    this.titleMesh.scale.set(
      content.text.title.scale,
      content.text.title.scale,
      content.text.title.scale
    );

    this.subtitleMesh.position.fromArray(content.text.subtitle.position);
    this.subtitleMesh.scale.set(
      content.text.subtitle.scale,
      content.text.subtitle.scale,
      content.text.subtitle.scale
    );

    const size = new Vector3();
    const center = new Vector3();
    const bbox = new Box3().setFromObject(this.group);
    bbox.getSize(size);
    bbox.getCenter(center);
    const padding = 0.25;
    const hitbox = new Mesh(
      new PlaneBufferGeometry(size.x + padding, size.y + padding),
      hiddenMaterial
    );
    hitbox.position.copy(center);
    hitbox.position.z -= 0.01;
    this.group.add(hitbox);

    // guiControls(this.gui, this.group, 50, 10);
    // guiControls(this.gui, this.titleMesh, 50, 10);
    // guiControls(this.gui, this.subtitleMesh, 10, 2, true);
    // guiSpacingControls(this.gui, this.subtitleMesh.children, 6);
    // this.gui.add(this, "export");
    this.interactiveObject = new InteractiveObject(hitbox, mainCamera, {
      touchStart: true,
      touchMove: true,
      touchEnd: true,
      mouseMove: false,
    });
    this.interactiveObject.on("start", this.onStart);
    this.interactiveObject.on("hover", this.onHover);
  }

  export = () => {
    const data = {
      title: {
        position: this.titleMesh.position.toArray(),
        scale: this.titleMesh.scale.x,
      },
      subtitle: {
        position: this.subtitleMesh.position.toArray(),
        scale: this.subtitleMesh.scale.x,
      },
    };
    window.prompt("Copy", JSON.stringify(data, null, 2));
  };

  onStart = (event) => {
    this.emit("click");
  };

  onHover = (over, event) => {
    toggleCursor(over);
  };
}
